
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-trees-carbon-calculator",
      function () {
        return require("private-next-pages/native-trees-carbon-calculator/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-trees-carbon-calculator"])
      });
    }
  